<template>
  <div class="charge-amount-sum-by-currency">
    <span style="color:deepskyblue;cursor:pointer;padding-left: 5px;" @click="toggle">
      {{ $t('CargoMsg.Cargo_AmountToDetail') }}
      <i :class="showPop?'el-icon-caret-top':'el-icon-caret-bottom'" />
    </span>
    <cargo-ag-grid
      v-show="showPop"
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 330px;height: 230px;position: absolute;bottom: 50px;right: 0;"
    />
  </div>
</template>

<script>
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'ChargeAmountSumByCurrency',
  props: {
    dataProvider: { type: Array, default: () => { return [] } }, // 需要统计的数据源
    arField: { type: String, default: 'AR' },
    cachePrefix: { type: String, default: '' } // 缓存前缀
  },
  data() {
    return {
      showPop: true,
      gridOptions: {},
      columnDefs: [],
      rowData: []
    }
  },
  computed: {
    showPopCacheKey() {
      return this.cachePrefix ? this.cachePrefix + '_showPop' : ''
    }
  },
  watch: {
    dataProvider() {
      this.refreshSum()
    },
    showPop(newVal) {
      if (this.showPopCacheKey) {
        LocalStorageUtilsNew.setConfiguration(this.showPopCacheKey, newVal)
      }
      this.triggerCallbak()
    }
  },
  created() {
    if (this.showPopCacheKey && LocalStorageUtilsNew.hasConfiguration(this.showPopCacheKey)) {
      this.showPop = Boolean(LocalStorageUtilsNew.getConfiguration(this.showPopCacheKey))
    }
    this.refreshSum()
  },
  methods: {
    toggle() {
      if (this.showPop) {
        this.showPop = false
      } else {
        this.showPop = true
      }
    },
    refreshSum() {
      this.columnDefs = []
      this.rowData = []
      if (this.dataProvider.length > 0) {
        const currencySet = new Set()
        const arCurrencyMap = new Map()
        const apCurrencyMap = new Map()
        const collectArRealCurrencyMap = new Map()
        const unArRealCurrencyMap = new Map()
        const collectApRealCurrencyMap = new Map()
        const unApRealCurrencyMap = new Map()
        for (const row of this.dataProvider) {
          const c = row.currency
          currencySet.add(c)
          if (row[this.arField]) {
            if (row.AMOUNT) {
              let amount = arCurrencyMap.get(c) || 0
              amount += row.AMOUNT
              arCurrencyMap.set(c, amount)
            }
            if (row.VERIFIED_AMOUNT) {
              let amount = collectArRealCurrencyMap.get(c) || 0
              amount += row.VERIFIED_AMOUNT
              collectArRealCurrencyMap.set(c, amount)
            }
            if (row.AMOUNT_UN) {
              let amount = unArRealCurrencyMap.get(c) || 0
              amount += row.AMOUNT_UN
              unArRealCurrencyMap.set(c, amount)
            }
          } else {
            if (row.AMOUNT) {
              let amount = apCurrencyMap.get(c) || 0
              amount += row.AMOUNT
              apCurrencyMap.set(c, amount)
            }
            if (row.VERIFIED_AMOUNT) {
              let amount = collectApRealCurrencyMap.get(c) || 0
              amount += row.VERIFIED_AMOUNT
              collectApRealCurrencyMap.set(c, amount)
            }
            if (row.AMOUNT_UN) {
              let amount = unApRealCurrencyMap.get(c) || 0
              amount += row.AMOUNT_UN
              unApRealCurrencyMap.set(c, amount)
            }
          }
        }
        if (currencySet.size > 0) {
          this.columnDefs.push({
            headerName: this.$t('Billing.billingCharge_currency'),
            field: 'dispName',
            width: 80
          })
          this.rowData.push({ dispName: this.$t('Message.Receivable') })
          this.rowData.push({ dispName: this.$t('Message.Payable') })
          this.rowData.push({ dispName: this.$t('CargoMsg.Cargo_Collected') })
          this.rowData.push({ dispName: this.$t('CargoMsg.Cargo_NotCollected') })
          this.rowData.push({ dispName: this.$t('CargoMsg.Cargo_PaidP') })
          this.rowData.push({ dispName: this.$t('CargoMsg.Cargo_SimpleUnpaidP') })
          for (const currency of currencySet) {
            this.columnDefs.push({
              headerName: currency,
              field: currency,
              valueFormatter: params => {
                return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2, '0.00'))
              },
              width: 80
            })
            this.rowData[0][currency] = arCurrencyMap.get(currency) || 0
            this.rowData[1][currency] = apCurrencyMap.get(currency) || 0
            this.rowData[2][currency] = collectArRealCurrencyMap.get(currency) || 0
            this.rowData[3][currency] = unArRealCurrencyMap.get(currency) || 0
            this.rowData[4][currency] = collectApRealCurrencyMap.get(currency) || 0
            this.rowData[5][currency] = unApRealCurrencyMap.get(currency) || 0
          }
        }
      }
      this.triggerCallbak()
    },
    triggerCallbak() {
      const arCurrencySum = []
      const apCurrencySum = []
      for (let i = 1; i < this.columnDefs.length; ++i) {
        const currency = this.columnDefs[i].field
        arCurrencySum.push({ currency, amount: NumberUtils.ToFixed2(this.rowData[0][currency], 2) })
        apCurrencySum.push({ currency, amount: NumberUtils.ToFixed2(this.rowData[1][currency], 2) })
      }
      this.$emit('callback', { showPop: this.showPop, arCurrencySum, apCurrencySum })
    }
  }
}
</script>

<style lang="scss" scoped>
.charge-amount-sum-by-currency ::v-deep {
  position: relative;
  display: flex;
  justify-content: flex-start;
  .cargo-ag-grid {
    .ag-theme-balham {
      min-height: unset !important;
    }
  }
}
</style>
